/**
 * Labstep
 *
 * @module components/Device/Breadcrumb
 * @desc Breadcrumb for Device Show page
 */

import { EntityTemplateBreadcrumbShow as EntityEntityTemplateBreadcrumbShow } from 'labstep-web/components/Entity/Template/Breadcrumb/Show';
import type React from 'react';
import type { DeviceBreadcrumbProps } from './types';

export const DeviceBreadcrumb: React.FC<DeviceBreadcrumbProps> = ({
  device,
}) => <EntityEntityTemplateBreadcrumbShow entity={device} />;
